import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { Tabs } from "@performyard/py-components";

// Components
import { Grid, GridCol } from "../../components/Grid";
import CompanyLinks from "./CompanyLinks";

import { useIsNewNavigation } from "../../api/hooks/defs/navigation";

import Documents from "../Documents";
import css from "./CompanyResources.module.scss";

const DOCUMENTS_PATH = "/company/resources/documents";
const LINKS_PATH = "/company/resources/links";

const CompanyResources = () => {
	const isNewNav = useIsNewNavigation();
	const location = useLocation();
	const navigate = useNavigate();

	const isLinks = location.pathname.includes("/links");
	const activeTab = isLinks ? "links" : "documents";

	const activeChild = isLinks ? <CompanyLinks /> : <Documents showEmployeeCard={false} />;

	if (isNewNav) {
		return activeChild;
	}

	const handleTabChange = (value: string) => {
		if (value === "documents") {
			navigate(DOCUMENTS_PATH);
		} else if (value === "links") {
			navigate(LINKS_PATH);
		}
	};

	return (
		<>
			<Grid className={css.Grid} cols={12} gap={4} padding={7}>
				<GridCol span={12}>
					<Tabs
						tabs={[
							{
								value: "documents",
								label: "Documents",
								content: <></>,
							},
							{
								value: "links",
								label: "Company Links",
								content: <></>,
							},
						]}
						value={activeTab}
						onValueChange={handleTabChange}
						color="neutral"
						size="large"
						dangerouslySetClassName="!gap-0"
					/>
				</GridCol>
			</Grid>
			{activeChild}
		</>
	);
};

export default CompanyResources;
